import { render, staticRenderFns } from "./AccountTypeSwitcher.vue?vue&type=template&id=27889b46&scoped=true"
import script from "./AccountTypeSwitcher.vue?vue&type=script&lang=js"
export * from "./AccountTypeSwitcher.vue?vue&type=script&lang=js"
import style0 from "./AccountTypeSwitcher.vue?vue&type=style&index=0&id=27889b46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27889b46",
  null
  
)

export default component.exports